export default __webpack_public_path__ + "static/gw2-icon-your-story-b277a44dbad9b525ccb9e39445ea4a9b.png";